module.exports = "<div baCardBlur\r\n\tclass=\"animated fadeIn card {{cardType}} {{baCardClass || ''}}\" zoom-in>\r\n\t<div *ngIf=\"title\" class=\"card-header clearfix\">\r\n\t\t<p class=\"card-title\" translate>{{title}}</p>\r\n\t\t<a *ngIf=\"link\" [attr.href]=\"link\">View <i class=\"fa fa-arrow-circle-right\"></i></a>\r\n\t</div>\r\n\t<div class=\"card-body\">\r\n\t\t<ng-content></ng-content>\r\n\t</div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/theme/components/baCard/baCard.html
// module id = 654
// module chunks = 16